import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import i18n from './i18n/i18n.js';

// Ia limba din localStorage și setează i18n la start
const savedLang = localStorage.getItem("lang") || "ro";
i18n.changeLanguage(savedLang);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
